<template>
<div id="gallery">
  <div class="container">
    <button @click="donate=!donate" id="btn-donate">打赏一杯咖啡 <font-awesome-icon icon="coffee"></font-awesome-icon></button>
    <div v-if="donate" id="donate">
      <img src="../assets/donate.png" />
    </div>
    <p>数据更新与功能建议 QQ群：775377433</p>
    <p><a href="http://kaikai.info/how-to-help-storm-voice-site/" target="_blank">如何帮助更新数据</a></P>
    <filterPanel :currentSide="currentSide" @listChanged="listChanged">
    </filterPanel>
    <keep-alive>
    <component :is="listTypeForComponent" :currentSide="currentSide" :twins="twinsToShow" :listType="listType"
    @sideChanged="sideChanged"></component>
    </keep-alive>
  </div>
</div>
</template>

<script>
import filterPanel from './filterPanel.vue'
import compareList from './listcompare.vue'
import musicList from './musiclist.vue'

export default {
  data () {
    return {
      donate :false,
      listType: "hero",
      twinsToShow: [{},{}],
      currentSide: 1
    }
  },
  computed:{
    listTypeForComponent(){return this.listType=="music"?"musicList":"compareList"},
  },
  methods:{
    listChanged(item){
      this.listType = item.libType;
      this.twinsToShow = item.twins;
    },
    sideChanged(e){
      this.currentSide=e;
    }
   },
  components:{
    filterPanel,
    compareList,
    musicList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
#gallery {
  padding-top:80px;
}
#donate {
  display:flex;
  justify-content: center;
  img{
    height: 240px;
  }
}
#btn-donate{
  height: 32px;
  width:120px;
  margin: 4px;
  background: #cde1ff;
  border:1px solid rgb(57, 159, 255);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/gallery.vue